const React = require('react');

module.exports = ({className, label, children}) => (
  <div className={
    `ref-field 
    (f12|fw4|lh18|c3E4044|mb3)>.ref-field__label
    (layoutRow|aiC|bgF|b1|bsSolid|bcDADADA|r9)>.ref-field__block`
    + (className ? ` ${className}` : '')
  }>
    {label && (
      <span className="ref-field__label">
        {label}
      </span>
    )}
    <div className="ref-field__block">
      {children}
    </div>
  </div>
)